export const FolderTreeService = Symbol.for('FolderTreeService');
